import { Button, Dialog, DialogActions, DialogTitle } from '@mui/material'
import { FC } from 'react'
import { TABLE_SECTION_MAX_NODE_COUNT } from './model'

type Props = {
  /** この行から貼り付けられる見出しの最大数。 */
  maxCount: number
  /** 貼り付けようとした見出しの数。 */
  pastedCount: number
  onClose: () => void
}

export const TableRowHeadingPasteOverLimitDialog: FC<Props> = ({
  maxCount,
  pastedCount,
  onClose,
}) => (
  <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>
      {`表の項目数（質問・条件分岐の合計）が上限${TABLE_SECTION_MAX_NODE_COUNT}を超えるため貼り付けできません。この行から貼り付けられるのは${maxCount}行までです（貼り付けようとした行数: ${pastedCount}行）。`}
    </DialogTitle>
    <DialogActions>
      <Button variant="outlined" onClick={onClose}>
        閉じる
      </Button>
    </DialogActions>
  </Dialog>
)
